export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13946.d78fb250.jpg";